import {REPORT_ALL_FRONTLINE_CLIENTS} from '/enum/records.enum';

export default {
  reportName: REPORT_ALL_FRONTLINE_CLIENTS,
};
